import { Link, useLocation } from 'react-router-dom';

import classNames from '@/lib/helper';
import { menuList } from '@/contexts/Menus';
import ToggleTheme from '@/components/ToggleTheme';

export default function Navbar() {
  const location = useLocation();

  const { pathname } = location;

  return (
    <nav className='fixed z-50 w-full bg-white dark:bg-gray-900'>
      <div className='max-w-4xl px-4 mx-auto'>
        <div className='flex justify-between'>
          <div className='flex space-x-7'>
            {/* Primary menu */}
            <div className='flex items-center space-x-1'>
              {menuList.map((menuItem) => (
                <Link
                  key={menuItem.name}
                  to={menuItem.link}
                  className={classNames(
                    'py-4 px-2 font-semibold font-sans transition duration-300 relative text-sm md:text-lg',
                    menuItem.link === pathname
                      ? 'after:absolute after:left-0 after:right-0 after:bottom-0 after:h-1 after:rounded-t-lg after:bg-gray-900 dark:after:bg-white'
                      : '',
                  )}
                >
                  {menuItem.title}
                </Link>
              ))}
            </div>
          </div>
          {/* Secondary menu */}
          <div className='flex items-center space-x-3'>
            <ToggleTheme />
          </div>
        </div>
      </div>
    </nav>
  );
}
